import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import 'moment/locale/pt-br';

@Component({
  selector: 'custom-datepicker-selected',
  templateUrl: './custom-datepicker-selected.component.html',
  styleUrls: ['./custom-datepicker-selected.component.scss']
})
export class CustomDatepickerSelectedComponent implements OnInit, AfterViewInit {

  public dataConsulta: Date | null = null;
  private lastMonthLabel: string | null = null;

  @Input() datas: any;
  @Input() isDisabled: boolean = false;;
  @Input() dataSelecionada: string;
  @Output() onSelected = new EventEmitter<any>();
  @Output() onAlterMonth = new EventEmitter<moment.Moment[]>();

  @ViewChild('picker') picker!: MatDatepicker<Date>;

  constructor(private _cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.dataSelecionada)
      this.dataConsulta = new Date(this.dataSelecionada);
  }

  ngAfterViewInit(): void {
    this.picker.openedStream.subscribe(() => {
      setTimeout(() => {
        const calendarElement = document.querySelector('mat-calendar');
        if (calendarElement) {
          const observer = new MutationObserver(() => {
            this.onMonthChanged();
          });
          observer.observe(calendarElement, {
            childList: true,
            subtree: true,
          });
        }
      });
    });
  }

  public updateDatas(novasDatas: Date[]): void {
    this.datas = novasDatas;
    this.filterDates = this.generateFilter();

    this._cdr.markForCheck();
    this._cdr.detectChanges();
  }

  protected selectedData(): void {
    this.onSelected.emit(this.dataConsulta);
  }

  public filterDates: (d: Date | null) => boolean = this.generateFilter();

  private generateFilter(): (d: Date | null) => boolean {
    return (d: Date | null): boolean => {
      if (!d) return false;
      return this.datas.some(available =>
        d.getDate() === available.getDate() &&
        d.getMonth() === available.getMonth() &&
        d.getFullYear() === available.getFullYear()
      );
    };
  }

  protected onMonthChanged(): void {
    const label =
      document.querySelector('.mat-calendar-period-button')?.textContent?.trim() ??
      document.querySelector('.mat-calendar-body-label')?.textContent?.trim();

    if (!label || label === this.lastMonthLabel) {
      return;
    }

    this.lastMonthLabel = label;

    const upper = label.toUpperCase();

    const match = upper.match(/([A-ZÇÃÕÉÊÍÓÔÚ\.]+)\s+DE\s+(\d{4})/);

    if (!match) {
      console.warn('Não consegui extrair mês/ano de:', label);
      return;
    }

    const mesAbrev = match[1].replace('.', '');
    const ano = Number(match[2]);

    const mesesAbrev = [
      'JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN',
      'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'
    ];

    const mesIndex = mesesAbrev.indexOf(mesAbrev);

    if (mesIndex === -1 || isNaN(ano)) {
      console.warn('Mês ou ano inválidos:', { mesAbrev, ano });
      return;
    }

    moment.locale('pt-br');
    const inicio = moment({ year: ano, month: mesIndex, day: 1 });
    const fim = inicio.clone().endOf('month');

    this.onAlterMonth.emit([inicio, fim]);
  }

}
